import React, { useState, useEffect } from 'react'
import colors from '../../styles/colors'
import { useWithAuth } from '../../containers/App'
import styled from 'styled-components'
import { useNotifications } from '../../containers/Notifications'
import Button from '../../components/Button'
import Heading from '../../components/Heading'
import Layout from '../../components/Layout'

import { ActiveQuestion } from './utils'

// @ts-ignore @todo add apprioprate declaration file
import shareIconUp from '../../images/shareIconUp.svg'

function SurveyStatus() {
  const surveyId = location.pathname.substring(
    location.pathname.lastIndexOf('/') + 1
  )
  const [survey, setSurvey] = useState({
    title: '',
    description: '',
    answeredCount: null,
    sentCount: null,
  })
  const [doneQuestions, setDoneQuestions] = useState<Array<ActiveQuestion>>([])
  const [sentImages, setSentImages] = useState({ files: [], filesId: [] })
  const endpoint = '/form/rest/survey/'
  const surveyImagesEndpoint = '/file/rest/image/'
  const withAuth = useWithAuth()
  const { notify } = useNotifications()
  const fetchSurvey = async () => {
    const result = await withAuth(`${endpoint}${surveyId}/answers`, {
      method: 'POST',
      payload: { email: null },
    })
    return result
  }
  const fetchSurveyAnswerImage = async (id) => {
    const result = await withAuth(`${surveyImagesEndpoint}${id}`, {
      method: 'GET',
      responseType: 'blob',
    })
    //await setImages([...images,{ file: URL.createObjectURL(result), fileId: id },])
    return URL.createObjectURL(result)
  }
  const fetchData = async () => {
    try {
      const result = await fetchSurvey()
      setSurvey({
        title: result.title,
        description: result.description,
        answeredCount: result.answeredCount,
        sentCount: result.sentCount,
      })
      setDoneQuestions(result.questions)
      const arrayOfFileids = result.questions
        .filter((question) => question.type === 'IMAGE')
        .map((question) =>
          question.answerOptions.map((option) => option.fileId)
        )
        .flat(1)

      const arrayOfImages = await Promise.all(
        arrayOfFileids.map(async (id) => await fetchSurveyAnswerImage(id)) //is empty skip
      )

      setSentImages({ files: arrayOfImages, filesId: arrayOfFileids })
    } catch {
      //notify('Nie udało się pobrać ankiety', 'error')
    }
  }
  useEffect(() => {
    fetchData()
  }, [])

  return (
    <Layout>
      <Heading title="Ankiety">
        <Button
          marginLeft
          link={`/app/surveys/send/${surveyId}`}
          label="Udostępnij"
          icon={shareIconUp}
          width="auto"
          altTag=""
          imgAriaHidden={true}
        />
      </Heading>
      <SurveyWrapper>
        <div>
          <Title>Tytuł ankiety, ({survey.title})</Title>
          <Description>
            Ankieta rozesłana do{' '}
            {survey.sentCount === 1
              ? `${survey.sentCount} osoby`
              : `${survey.sentCount} osób`}
            , zebrano{' '}
            {survey.answeredCount === 1
              ? `${survey.answeredCount} odpowiedź`
              : `${survey.answeredCount} odpowiedzi`}{' '}
          </Description>
        </div>
        <QuestionsWrapper>
          {doneQuestions !== [] &&
            doneQuestions.map((question, index) => (
              <QuestionWrapper key={index}>
                <Title>
                  Pytanie {index + 1}: {question.question}{' '}
                </Title>
                {(question.type === 'SHORT' || question.type === 'LONG') && (
                  <StyledAnswers>
                    {question?.answers?.map((answer, index) => (
                      <StyledSpan key={index}>{answer}</StyledSpan>
                    ))}
                  </StyledAnswers>
                )}
                <AnswersWrapper isImage={question.type === 'IMAGE'}>
                  {question.answerOptions.map((answer, index) => (
                    <>
                      {question.type === 'MULTIPLE' && (
                        <RadioGroup>
                          <RadioDot />
                          <Group>{`${answer.answer}, ${answer.percent}%`}</Group>
                        </RadioGroup>
                      )}
                      {(question.type === 'SINGLE' ||
                        question.type === 'LIKERT') && (
                        <RadioGroup>
                          <RadioDot isRadio />
                          <Group>{`${answer.answer}, ${answer.percent}%`}</Group>
                        </RadioGroup>
                      )}
                      {question.type === 'IMAGE' && answer.fileId !== null && (
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            marginRight: '1em',
                          }}
                        >
                          <label>
                            <Image
                              src={
                                sentImages.files[
                                  sentImages?.filesId.indexOf(answer.fileId)
                                ]
                              }
                            ></Image>
                          </label>
                          <Group>{`${answer.answer}, ${answer.percent}%`}</Group>
                        </div>
                      )}
                    </>
                  ))}
                </AnswersWrapper>
              </QuestionWrapper>
            ))}
        </QuestionsWrapper>
      </SurveyWrapper>
    </Layout>
  )
}

export default SurveyStatus

const Group = styled.p`
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  margin: 0.3rem;
`
const Image = styled.img`
  max-width: 200px;
  min-width: 200px;
  max-height: 112.5px;
  border: 2px solid ${colors.monza};
  border-radius: 4px;
`
const QuestionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
`
const QuestionWrapper = styled.div`
  background: rgba(234, 234, 234, 1);
  margin-top: 1rem;
  padding: 1rem;
  border-radius: 6px;
`
const SurveyWrapper = styled.div`
  margin: 5vh 10vw;
`

const AnswersWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: ${(props) => (props.isImage ? 'row' : 'column')};
`

const Title = styled.p`
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 23px;
`
const Description = styled.p`
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 19px;
`
const RadioDot = styled.span`
  height: 12px;
  width: 12px;
  background-color: ${colors.monza};
  ${(props) => props.isRadio && `border-radius: 50%;`}
  display: inline-block;
`
const RadioGroup = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
`
const StyledSpan = styled.span`
  background: rgba(196, 196, 196, 0.5);
  padding: 1rem;
  border-radius: 4px;
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  margin-top: 1rem;
`
const StyledAnswers = styled.div`
  display: flex;
  max-height: 600px;
  overflow-y: auto;
  flex-direction: column;
`
